import { Fragment, useEffect, useState } from 'react'
import PageHeader from './utils/PageHeader'
import { CardBody, Table, Badge } from 'reactstrap'
import { API_URL } from './utils/Constants/URLS'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

const ViewFocSalesOrder = () => {
    const token = localStorage.getItem('token')
    const userDetails = useSelector(store => store.user)
    const [soData, setSoData] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchFocSalesOrders = async () => {
            setLoading(true)
            try {
                // Fetch FOC Sales Orders pending approval for Commercial Manager
                const res = await fetch(
                    `${API_URL}foc/sales-order/approvals`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                const result = await res.json()
                setSoData(result?.data || [])
            } catch (e) {
                console.log('Error fetching FOC Sales Orders:', e)
            } finally {
                setLoading(false)
            }
        }
        fetchFocSalesOrders()
    }, [token])

    const formatDate = date =>
        date
            ? new Date(date).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            })
            : '-'

    const getStatusBadge = (status) => {
        switch (status) {
            case 'approved':
                return <Badge color="success">Approved</Badge>
            case 'rejected':
                return <Badge color="danger">Rejected</Badge>
            case 'pending':
            default:
                return <Badge color="warning">Pending Approval</Badge>
        }
    }

    // Only Commercial Manager should see this page
    if (userDetails?.role !== 'commercial_manager') {
        return (
            <Fragment>
                <PageHeader
                    pageName='FOC SALES ORDER APPROVAL'
                    breadcrump1='Home'
                    breadcrump2='FOC SO Approval'
                    link='/dashboard'
                />
                <div className='main lg:p-6 xl:p-6 2xl:p-6 sm:p-3 md:p-3'>
                    <CardBody>
                        <div className='alert alert-warning text-center'>
                            <i className='bi bi-exclamation-triangle me-2'></i>
                            You do not have permission to view this page. Only Commercial Managers can approve FOC Sales Orders.
                        </div>
                    </CardBody>
                </div>
            </Fragment>
        )
    }

    return (
        <Fragment>
            <PageHeader
                pageName='FOC SALES ORDER APPROVAL'
                breadcrump1='Home'
                breadcrump2='FOC SO Approval'
                link='/dashboard'
            />
            <div className='main lg:p-6 xl:p-6 2xl:p-6 sm:p-3 md:p-3'>
                <CardBody>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <h5 className='mb-0'>FOC Sales Orders Pending Approval</h5>
                    </div>
                    <div className='table-responsive sm:overflow-auto sm:max-h-[400px] w-full mb-3'>
                        {loading ? (
                            <div className='text-center py-4'>
                                <div className='spinner-border text-primary' role='status'>
                                    <span className='visually-hidden'>Loading...</span>
                                </div>
                            </div>
                        ) : soData.length === 0 ? (
                            <div className='alert alert-info text-center'>
                                No FOC Sales Orders pending approval.
                            </div>
                        ) : (
                            <Table hover className='align-middle table-nowrap'>
                                <thead className='table-light'>
                                    <tr>

                                        <th>Lead Details</th>
                                        <th>Created By</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {soData.map((data, index) => {
                                        const so = data?.salesOrder || data
                                        return (
                                            <tr key={index}>

                                                <td>
                                                    {so?.lead?.leadId || 'N/A'} | {so?.lead?.leadJourneyName || 'FOC Lead'}
                                                </td>
                                                <td>{data?.createdBy?.name || so?.createdBy?.name || '-'}</td>
                                                <td>{formatDate(so?.createdAt || so?.dateOfSO)}</td>
                                                <td>{getStatusBadge(so?.status)}</td>
                                                <td>
                                                    <Link
                                                        to={`/view_foc_so/${so?._id}`}
                                                        className='btn btn-sm btn-primary'
                                                    >
                                                        View Details
                                                    </Link>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </CardBody>
            </div>
        </Fragment>
    )
}

export default ViewFocSalesOrder
